import React from 'react'
import PropTypes from 'prop-types'
import { classNames, variationName } from './../../utils/styles'

import { iconLoader } from './../../utils/svg'

import styles from './Icon.scss'

import * as icons from './../../assets/icons'

export default function Icon({ source, color, backdrop, className, size = 'Medium', accessibilityLabel }) {
  const iconClassName = classNames(
    styles.Icon,
    color && styles[variationName('color', color)],
    color && color !== 'white' && styles.isColored,
    size && styles[variationName('Icon--size-', size)],
    backdrop && styles.hasBackdrop,
    className,
  )

  let contentMarkup
  const useFont = source.indexOf('fa') === 0 || source.indexOf('icon') === 0 || source.indexOf('ft') === 0

  if (useFont) {
    return <i className={classNames(styles.Font, source, className)} />
  }

  if (source === 'placeholder') {
    contentMarkup = <div className={styles.Placeholder} />
  } else {
    const iconSource = iconLoader(icons[source])
    contentMarkup = iconSource &&
      iconSource.viewBox &&
      iconSource.body && (
        <svg
          width="40"
          height="40"
          className={styles.Svg}
          viewBox="0 0 24 24"
          dangerouslySetInnerHTML={{ __html: iconSource.body }}
          focusable="false"
          aria-hidden="true"
        />
      )
  }

  return (
    <span className={iconClassName} aria-label={accessibilityLabel}>
      {contentMarkup}
    </span>
  )
}

Icon.propTypes = {
  source: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
  backdrop: PropTypes.bool,
  accessibilityLabel: PropTypes.string,
  className: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/Icon/index.js